import React, { useState } from "react";
import "./LeaveApplicationHOD.css";
import axios from "axios";
import LeaveApplicationHODTable from "./LeaveApplicationHODTable.jsx";
// import LeaveApplicationHODForm from "./LeaveApplicationHODForm.jsx";
import LeaveApplicationHODFormEdit from "./LeaveApplicationHODFormEdit.jsx";
export default function LeaveApplicationHOD(props) {
  const [table, setTable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [SelectedEmp, setSelectedEmp] = useState([]);
  const handleLeaveApplicationHODSubmit = (event) => {
    event.preventDefault();
    // console.log("id", event.target[0].value, event.target[1].value);
    setTable(true);

    let body = {
      //  CompanyName: event.target[0].value,
      //  Designation:  event.target[1].value,
      //  FromDate:  event.target[2].value,
      //  ToDate:  event.target[3].value,

      Leavetype: event.target[0].value,
      FromDate: event.target[1].value,
      ToDate: event.target[2].value,
      Reasonforleave: event.target[3].value,
      Status: event.target[4].value,
    };
    axios
      .post(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-application-hod/" +
          props.data["_id"],
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleAddLeaveApplicationHOD = () => {
    // // console.log("clicked1");
    setTable(false);
  };
  const handleEditLeaveApplicationHOD = (e) => {
    console.log(e);
    // console.log("clicked6");

    setEditForm(true);
    setEditData(e);
  };
  const handleFormClose = () => {
    // // console.log("clicked1");
    setTable(true);
  };
  const handleEditFormClose = () => {
    // console.log("clicked5");

    setEditForm(false);
  };

  const handleLeaveApplicationHODEditUpdate = (info, newInfo, id) => {
    newInfo.preventDefault();

    let body = {
      Status: newInfo.target[4].value,
    };
    console.log("update", body);
    axios
      .put(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-report-hod/" +
          id,
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        setTable(false);
        setTable(true);
      })
      .catch((err) => {
        console.log(err);
      });
    setEditForm(false);
  };

  return (
    <React.Fragment>
      {table ? (
        editForm ? (
          <LeaveApplicationHODFormEdit
            onLeaveApplicationHODEditUpdate={
              handleLeaveApplicationHODEditUpdate
            }
            onFormEditClose={handleEditFormClose}
            editData={editData}
          />
        ) : (
          <LeaveApplicationHODTable
            onAddLeaveApplicationHOD={handleAddLeaveApplicationHOD}
            onEditLeaveApplicationHOD={handleEditLeaveApplicationHOD}
            data={props.data}
            SelectedEmp={SelectedEmp}
            setSelectedEmp={setSelectedEmp}
          />
        )
      ) : (
        <div></div>
      )}
    </React.Fragment>
  );
}
